<template class="prueba test">
    <el-card class="box-card" :class="{ 'box-shadow-active': isSupervised, 'box-mini-floating':  !stats }"  :data-agent="JSON.stringify(agent)">
        <div class='card-top row gx-4'>
            <el-avatar :src="agent.picture">{{ getAcronym( agent.name ) }}</el-avatar>
            <div class="card-top-info">
                <p :class="styleName" class="name">{{ agent.name }} ({{ agent.number }})</p>
                <div v-if="!isOffline" class="timer">
                    {{ $t("agent-console.logged_started_at") }} 
                    <Chronometer style="display: inline-block;" :timestamp="agent.logged_started_at"  />
                </div>
                <p v-else class="offline">{{ $t("user-status.disconnected") }}</p>
            </div>
            <div class="card-logged-status" v-if="showStatus">
                <p :class="{'logged': agent.call_logged }" class="icon"><i class="fa fa-phone-alt"></i><span class='hide'>{{ $t("agent-console.call") }}</span></p>
                <p :class="{'logged': agent.chat_logged }" class="icon"><i class="far fa-comment-dots"></i><span class='hide'>{{ $t("agent-console.chat.chat") }}</span></p>
            </div>
            <!-- <SpyWhisper v-if="spy_whisper" :agent_number="agent.extension" ref="sw"></SpyWhisper> -->
            <TheDropdownAgentCard :agent="agent" v-if="showActions"></TheDropdownAgentCard>
        </div>

        <div class='card-middle'>
			<div class='row row-center'>
				<div v-if="isOffline" class='offline'>
					<p>
						<i class="fas fa-headset"></i>
						<span class="fake-status">{{ $t('user-status.disconnected') }}</span>
					</p>
					<span class='fake-chronometer'>&nbsp;</span>
				</div>
				<div v-else-if="isAvailable">
					<p>
						<i class="fas fa-headset"></i>
						<span>{{ $t('user-status.connected') }}</span>
					</p>
					<span class='fake-chronometer'>&nbsp;</span>
				</div>
				<div v-else>
					<p>
						<i :class="callTypeClassName"></i>
						<span class="call-type-name">{{ callTypeName }}</span>
					</p>
					<Chronometer style="display: inline-block;" :timestamp="agent.call_started" v-if="agent.call_started" />
				</div>
				
				
				<div v-if="agent.in_break">
					<p>
						<i class="fas fa-coffee"></i>
						<span class="call-type-name">{{ agent.break_name }}</span>
					</p>
					<Chronometer style="display: inline-block;" :timestamp="agent.break_started_at" v-if="agent.break_started_at"/>
				</div>
			</div>
        </div>

        <div class='card-bottom' v-if="stats">
			<h3>{{ $t("agent-console.calls") }}</h3>
            <ul>
                <li>
                    {{ $t("agent-console.calls_total.incoming") }}
                    <p>{{ agent.calls_total.incoming }} </p>
                </li>
                <li>
                    {{ $t("agent-console.calls_total.outgoing") }}
                    <p>{{ agent.calls_total.outgoing }} </p>
                </li>
                <li>
                    {{ $t("agent-console.calls_total.failed") }}
                    <p>{{ agent.calls_total.failed ?? 0}} </p>
                </li>
            </ul>
        </div>
    </el-card>
</template>

<script>
import Chronometer from "@/components/common/Chronometer";
// import SpyWhisper from "@/components/dashboard/TheAgentSpyWhisper";
import TheDropdownAgentCard from "@/components/dashboard/TheDropdownAgentCard";
import { mapGetters } from 'vuex';

export default {
  name: "TheAgentCard",
  data( ){
    return {
        types: {
            spy: 551,
            whisper: 553
        }
    }
  },
  props: {
    ellipsis:{
        required: false,
        default: false
    },
    stats:{
        required: false,
        default: false
    },
    spy_whisper:{
        required: false,
        default: false
    },
    showActions: {
        required: false,
        default: true
    },
    agent : {
        required : true,
        default : () => {
            return {
                number : 0,
                call_status : '',
                call_logged : false,
                chat_logged : false,
                in_break : false,
                call_type: null
            }
        }
    },
    showStatus: {
        required: false,
        default: true,
    }
  },
  methods:{
    getAcronym( name ){
        if( ! name ) return ''; 
        return name.substr(0,1).toUpperCase( );
    }
  },
  computed:{
    ...mapGetters({ getIsInCallWith : 'getIsInCallWith' }),
    isSupervised(){
        if(this.getIsInCallWith){
            if( this.types.spy && this.getIsInCallWith ==  `*${this.types.spy}${this.agent.extension}` ) return true;
            if( this.types.whisper && this.getIsInCallWith == `*${this.types.whisper}${this.agent.extension}` ) return true;
        }
        return false;
    },
	isAvailable( ){
		return ( ( this.agent.chat_logged || this.agent.call_logged ) && ! this.agent.in_break && ! this.agent.call_type);
	},
    isOffline(){
        return ! this.agent.chat_logged && ! this.agent.call_logged
    },
    styleName(){
        return "mb-0" + ( this.ellipsis ? ' ellipsis': '' );
    },
    columnStyle(){
        let str_style = this.agent.in_break ? '' : 'reverse';
        if( !this.agent.call_type && !this.agent.in_break ) str_style += ' idle';
        return str_style;
    },
    callTypeName(){
        return this.agent.call_type ?
            this.$t("agent-console.in_call"):
            this.$t("agent-console.not_in_call");
    },
    callTypeClassName(){
        return !this.agent.call_type ? 
            "fas fa-headset" : 
            'fas hm-icon hm-' + this.agent.call_type;
    }
  },
  components: {
    Chronometer,
    // SpyWhisper,
    TheDropdownAgentCard
  }
};
</script>
<style>
#agent-dashboard-cards .agent-card .el-card__body{
	padding: 13px;
}
</style>
<style scoped>
.hide{
    display: none;
}

.ellipsis{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.name {
    font-weight: bold;
}

.box-shadow-active{
    box-shadow: 0 4px 15px 0 rgb(116 246 101 / 39%), -1px 1px 10px 0 rgb(65 186 35 / 47%) !important
}

.el-card__body{
	padding: 0 !important;
}

/* CARDS */
.box-card{
	font-size: 0.84rem;
}

.box-card .row{
    margin-left: 0;
    margin-right: 0;
    display: flex;
}

.box-card ul.row{
	font-size: 1.1em;
}

.box-card .card-top{
    gap: .5em;
    margin-bottom: .4em;
	flex-wrap: nowrap;
}

.box-card .card-top-info{
	flex: 1;
	overflow: hidden;
}

.box-card .card-top .timer,
.box-card .card-top .offline{
    font-size: .8em;
    height: 3.2em;
}

.box-card .card-top .offline{
	color: var(--danger);
	margin-bottom: 0;
}

.box-card .card-top p.icon{
    margin: 0;
}

.box-card .card-middle .row-center .fake-chronometer,
.box-card .card-middle .row-center :deep( .chronometer ){
	font-size: .8rem !important;
	line-height: 1rem !important;
}

.box-card .card-middle .row-center :deep( .chronometer .fa-clock ){
	margin-left: 5px;
}

.box-card .card-middle .row-center{
	justify-content: center;
	gap: 15px;
}

.box-card .card-middle .row-center div{
	max-width: calc( 50% - 12px );
	text-align: center;
}

.box-card .card-middle .row-center div.offline{
	opacity: 0.3;
}

.box-card .card-middle .row-center div p{
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: .3em 0 0;
}

.box-card .card-middle .row-center div .call-type-name{
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.box-card .card-middle .row-center i{
	font-size: 28px;
	line-height: 28px;
	margin: 0 0 .2em 0;
	padding :0;
}

.box-card .card-middle .row-center i.fa-coffee,
.box-card .card-middle .row-center i.fa-headset{
	line-height: 33px;
}

.box-card .card-middle .row-center .fake-status,
.box-card .card-middle .row-center div p span{
	font-size: 0.74rem;
	line-height: 1.5em;
}

.box-card .card-bottom{
    display: flex;
    flex-direction: column;
    padding: 0.75rem 7px 0;
    font-size: .87em;
	margin-top: .75rem;
	border-top: 1px solid var(--grey-status);
}


.box-card .card-bottom h3{
	font-size: 1.4em;
    line-height: 1;
}

.box-card .card-bottom ul{
	list-style: none;
	margin: 0 ;
}

.box-card .card-bottom ul li{
	display: flex; 
	justify-content: space-between;
	align-items: center;
	font-size: 1.13em;
	line-height: 1;
	margin: 0 0 .6em 0;
}

.box-card .card-bottom ul li p{
	margin: 0;
}



/* FONT AWESOME */
.icon{
    color: var(--grey-status);
}

.fa, .fal, .far {
    display: inline-block;
}

.fa-coffee {
    color: var(--red);
}

.fa-phone,
.logged {
    color: var(--green);
}

.fa-headset {
    color: var(--other-blue);
}


/* ICONOS EXTRA */

.hm-icon::before{
    content: "";
    display: inline-block;
    height: 1em;
    width: 1em;
    background-size: contain;
}

.hm-outgoing::before{
    background-image: url('data:image/svg+xml;base64,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');
}

.hm-incoming::before{
    background-image: url('data:image/svg+xml;base64,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');
}

:deep( .timer ){
	font-size: 0.8em !important
}
:deep( .chronometer ){
	font-size: 1em !important;
}

/* MINI FLOATING CARD */
.box-card.box-mini-floating .card-top{
	flex-direction: column;
}

.box-card.box-mini-floating .el-avatar{
	display: none;
}

.box-card.box-mini-floating .card-top-info{
	width: 100%;
}

.box-card.box-mini-floating .card-logged-status{
	display: flex;
	justify-content: center;
	gap: 30px;
}

.box-card.box-mini-floating .card-logged-status p{
	font-size: 1.4em;
}

/*
.box-card.box-mini-floating .card-bottom.reverse > div:first-child{
    display: none;
}

.box-card.box-mini-floating .invisible,
.box-card.box-mini-floating .card-bottom.idle{
    display: none;
}
*/

.box-card.box-mini-floating :deep( .fa-clock ){
	font-size: 1.2em !important;
}
</style>